import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`;

const CollectionSkeletonLoader = ({ theme = "dark", count = 6 }) => {
  return (
    <CollectionContainer>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonItem key={index} theme={theme}>
          <SkeletonThumbnail theme={theme} />
          <SkeletonFooter>
            <SkeletonDate theme={theme} />
            <SkeletonModelName theme={theme} />
          </SkeletonFooter>
        </SkeletonItem>
      ))}
    </CollectionContainer>
  );
};

export default CollectionSkeletonLoader;

const CollectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  padding: 0px 16px;
  @media (max-width: 500px) {
    justify-content: center;
  }
`;

const SkeletonItem = styled.div`
  width: 100%;
  max-width: 338px;
  height: 400px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  @media (max-width: 470px) {
    max-width: 100%;
    height: 450px;
  }
`;

const SkeletonThumbnail = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) =>
    props.theme === "light"
      ? "linear-gradient(90deg, #e0e0e0 0px, #f0f0f0 40px, #e0e0e0 80px)"
      : "linear-gradient(90deg, #1a1a1a 0px, #2a2a2a 40px, #1a1a1a 80px)"};
  background-size: 468px 100%;
  animation: ${shimmer} 1.5s infinite linear, ${pulse} 2s infinite ease-in-out;
  border-radius: 12px;
`;

const SkeletonFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 61.05%,
    rgba(0, 0, 0, 0.64) 100%
  );
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: flex-end;
  gap: 4px;
`;

const SkeletonDate = styled.div`
  height: 14px;
  width: 40%;
  max-width: 100px;
  border-radius: 4px;
  margin-bottom: 4px;
  background: ${(props) =>
    props.theme === "light"
      ? "linear-gradient(90deg, rgba(255,255,255,0.3) 0px, rgba(255,255,255,0.5) 40px, rgba(255,255,255,0.3) 80px)"
      : "linear-gradient(90deg, rgba(255,255,255,0.1) 0px, rgba(255,255,255,0.2) 40px, rgba(255,255,255,0.1) 80px)"};
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite linear;
`;

const SkeletonModelName = styled.div`
  height: 14px;
  width: 60%;
  max-width: 140px;
  border-radius: 4px;
  background: ${(props) =>
    props.theme === "light"
      ? "linear-gradient(90deg, rgba(255,255,255,0.4) 0px, rgba(255,255,255,0.6) 40px, rgba(255,255,255,0.4) 80px)"
      : "linear-gradient(90deg, rgba(255,255,255,0.15) 0px, rgba(255,255,255,0.25) 40px, rgba(255,255,255,0.15) 80px)"};
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite linear;
`;
